import {TranslationFunction} from 'translations';
import {IAddress, ICustomerAddress} from 'types';

export const getStreetNameFromAddress = (address: IAddress) => {
  if (!address) return '';
  return `${address.street ?? address.street_name} ${address.number}`;
};

export const getAddressDetails = (address: IAddress, t: TranslationFunction) => {
  if (!address) return '';
  if (address.is_private_building) return t('ADDRESS_PRIVATE_HOUSE');
  if (!address.apartment) return t('ADDRESS_PRIVATE_HOUSE');
  const apT = t('ADDRESS_APT_OFFICE');
  const flT = t('FLOOR');
  const enT = t('STAIRS');
  const interT = t('INTER_PHONE');
  const interPhone = address.entrance_code ? `, ${interT}: ${address.entrance_code}` : '';
  return `${apT}: ${address.apartment},  ${enT}: ${address.entrance}, ${flT}: ${address.floor}${interPhone}`;
};

export const isStauceni = (selectedAddress: ICustomerAddress | undefined) => {
  if (!selectedAddress) return false;
  if (selectedAddress.address?.delivery_region_data?.length > 0) {
    return selectedAddress.address.delivery_region_data[0].id === 6; //6 = stauceni
  } else {
    return false;
  }
};

export const trimAddressSearchValue = (address: string) => {
  const streetNameMatch = address.match(/^[^\d]+/);
  return streetNameMatch ? streetNameMatch[0].trim() : '';
};
